// extracted by mini-css-extract-plugin
module.exports = {"notificationsWrapper":"NotificationsManager_notificationsWrapper__1osT0","centeredNotificationsWrapper":"NotificationsManager_centeredNotificationsWrapper__KcCcf"};